module.exports = __webpack_public_path__ + "static/media/grp_logo.3c656c86.png";